import { render, staticRenderFns } from "./JustImageSettings.vue?vue&type=template&id=69890c6e&scoped=true&"
import script from "./JustImageSettings.vue?vue&type=script&lang=js&"
export * from "./JustImageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69890c6e",
  null
  
)

export default component.exports